exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flex-dropdown-box[data-v-7e4493d8]{border-top:0 solid transparent;border-bottom-right-radius:10px;border-bottom-left-radius:10px}", ""]);

// exports
